import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import FooterNav from './FooterNav';

const {FiHeart, FiInfo} = FiIcons;

function TransparencyBanner() {
  return (
    <footer className="site-footer">
      <div className="container footer-main">
        <div className="footer-brand">
          <strong>
            <a href="/">MedicalCodingClassesOnline.com</a>
          </strong>
          <span>
            100% Online Classes for Medical Billing and Coding. Independent foundational
            education for aspiring professionals.
          </span>
          <FooterNav />
        </div>
        <span className="made-with">
          <SafeIcon icon={FiHeart} /> Made for focused learners
        </span>
      </div>

      <div className="transparency-banner">
        <div className="container">
          <SafeIcon icon={FiInfo} />
          <p>
            <strong>Educational transparency:</strong> This platform provides non-certified
            practice tools and educational guides for study preparation. It is not an
            accredited program, formal training provider, or substitute for an official
            certification course or current code set resources.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default TransparencyBanner;